import { Button } from "@mui/material";
import axios from "axios";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { ImagePicker } from "../../../Shared/useImageCrop/ImagePicker";
import RichTextEditorCustom from "../../../Shared/CustomRichTextEditor";

export default function Addnews() {
  const [title, setTitle] = useState("");
  const [metaKeyword, setMetaKeyword] = useState("");
  const [metaDescription, setMetaDescription] = useState("");
  const [content, setContent] = useState("");
  const [image, setImage] = useState(null);
  const navigate = useNavigate();

  const addnews = (event) => {
    event.preventDefault();
    const reqbody = new FormData();
    reqbody.append("store", localStorage.getItem("store_id"));
    reqbody.append("Title", title);
    reqbody.append("meta_keyword", metaKeyword);
    reqbody.append("meta_description", metaDescription);
    reqbody.append("Content", content);
    image && reqbody.append("images", image);

    axios
      .post(
        "https://m1blog.aaragroups.com/blog/api/admin/api/news_list_api/",
        reqbody,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            token: localStorage.getItem("token"),
          },
        },
      )
      .then((response) => {
        toast.success(response.data.message);
        navigate("/news");
      })
      .catch((error) => {
        console.error("Error adding blog:", error);
        toast.error("Failed to add news");
      });
  };

  return (
    <div className="flex flex-col w-full min-h-screen bg-gray-100 p-4">
      <div className="max-w-5xl w-full mx-auto bg-white shadow-lg rounded-lg p-6">
        <h2 className="text-2xl font-bold text-center border-b-2 border-gray-300 pb-3 mb-6">
          Add News
        </h2>

        <form onSubmit={addnews} className="space-y-6">
          {/* Grid for Title, Meta Description, Meta Keyword, Image */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            <div className="flex flex-col">
              <label className="text-sm font-semibold mb-1">Title</label>
              <input
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                placeholder="Enter title"
                className="w-full p-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
              />
            </div>

            <div className="flex flex-col">
              <label className="text-sm font-semibold mb-1">
                Meta Description
              </label>
              <input
                value={metaDescription}
                onChange={(e) => setMetaDescription(e.target.value)}
                placeholder="Enter meta description"
                className="w-full p-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
              />
            </div>

            <div className="flex flex-col">
              <label className="text-sm font-semibold mb-1">Meta Keyword</label>
              <input
                value={metaKeyword}
                onChange={(e) => setMetaKeyword(e.target.value)}
                placeholder="Enter meta keywords"
                className="w-full p-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
              />
            </div>

            <div className="flex flex-col">
              <label className="text-sm font-semibold mb-1">Image</label>
              <ImagePicker placeholder="Choose Image" handleChange={setImage} />
            </div>
          </div>

          {/* Content */}
          <div className="flex flex-col">
            <label className="text-sm font-semibold mb-1">Content</label>
            <RichTextEditorCustom
              value={content}
              className="h-60 mb-3 border border-gray-300 rounded"
              onChange={setContent}
            />
          </div>

          {/* Submit Button */}
          <div className="flex justify-center">
            <Button
              type="submit"
              variant="contained"
              size="large"
              className="!w-32"
            >
              Add News
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
